import Button from '@mui/material/Button'
import { planUsageOutlineButtonSx } from './planUsageOutlineButtonSx'

/**
 * @param {{ children: string, onClick?: () => void, 'aria-label'?: string, variant?: 'outline' | 'soft' }} props
 */
export default function PlanUsageOutlineButton({ children, onClick, 'aria-label': ariaLabel, variant = 'outline' }) {
  const isOutline = variant === 'outline'
  return (
    <Button variant="text" size="small" onClick={onClick} aria-label={ariaLabel ?? children} sx={planUsageOutlineButtonSx(isOutline)}>
      {children}
    </Button>
  )
}
